import { NumberInput, useNotify, useRecordContext } from "react-admin";
import Edit from "@mui/icons-material/Edit";
import { specialistRequests } from "api/specialistApi";
import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import { Add } from "@mui/icons-material";
import { validateDiplomaGrade } from "utils/validations";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const ChangeDiplomaGradeModal = ({ getDetails }) => {
  const notify = useNotify();
  const notifyError = useNotifyError();
  const record = useRecordContext();
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const isExistingGrade = record?.diplomaGrade !== null && record?.diplomaGrade !== undefined;

  const handleSent = async data => {
    const confirmData = {
      grade: data.diplomaGrade,
    };
    try {
      await dataProvider.customRequest(
        specialistRequests.patchCampaignApplicationDiplomaGrade(data.campaignId, data.id),
        confirmData,
        "PATCH",
      );

      notify(`Успешна редакция на оценка от диплома`, { type: "success" });
      getDetails();
    } catch (e) {
      if (e?.properties?.length > 0) {
        handleConflictError(e);
      } else {
        notifyError(e);
      }
      return false;
    }
  };

  return (
    <>
      <FormModal
        titleContent={`${isExistingGrade ? "Редакция на оценка от диплома" : "Добавяне на оценка от диплома"}`}
        onConfirm={handleSent}
        startIcon={isExistingGrade ? <Edit /> : <Add />}
        titleButton={`${isExistingGrade ? "Редакция" : "Добавяне"}`}
        btnStyle={{ width: "max-content" }}
      >
        <Grid
          container
          spacing={2}
          display="flex"
          justifyContent="center"
        >
          <Grid
            item
            xs={12}
            md={8}
          >
            <NumberInput
              source="diplomaGrade"
              label="Оценка от Диплома"
              validate={validateDiplomaGrade}
            />
          </Grid>
        </Grid>
      </FormModal>
      <ConflictErrorDialog />
    </>
  );
};

export default ChangeDiplomaGradeModal;
